import { createUserWithEmailAndPassword, signOut } from "firebase/auth";
import { authSecundaria } from "./api_firebase";
import { crearLog } from "../pages/components/logs/logs";

export const crearUsuarioAuth = async (email, password) => {
  if (!email || !password) {
    throw new Error("Se requieren email y contraseña válidos");
  }

  if (password.length < 6) {
    throw new Error("La contraseña debe tener al menos 6 caracteres");
  }

  try {
    console.log("👤 Creando usuario en Authentication:", email);
    
    const userCredential = await createUserWithEmailAndPassword(authSecundaria, email, password);
    const user = userCredential.user;
    await signOut(authSecundaria);
    
    console.log("✅ Usuario creado en Auth con UID:", user.uid);

    await crearLog(`auth/usuarios/${email}`, "crear");

    return {
      uid: user.uid,
      email: user.email,
      success: true,
      message: "Usuario creado correctamente en Authentication"
    };

  } catch (error) {
    console.error("❌ Error al crear usuario en Authentication:", error.message);
    
    let mensajeError = "Error desconocido al crear usuario";
    
    switch (error.code) {
      case "auth/email-already-in-use":
        mensajeError = "El correo electrónico ya está registrado";
        break;
      case "auth/invalid-email":
        mensajeError = "El correo electrónico no es válido";
        break;
      case "auth/operation-not-allowed":
        mensajeError = "La creación de usuarios está deshabilitada";
        break;
      case "auth/weak-password":
        mensajeError = "La contraseña es muy débil";
        break;
      default:
        mensajeError = error.message;
    }

    throw new Error(mensajeError);
  }
};